import { Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../../../../environments/environment';

export const b2cPolicies = {
  scopes: [`api://${environment.azure.clientId}/access_as_user`],
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.azure.clientId,
    authority: `https://login.microsoftonline.com/${environment.azure.tenantId}`,
    redirectUri: environment.azure.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

export const protectedResources = {};

export const loginRequest = {
  scopes: [`api://${environment.azure.clientId}/access_as_user`],
};
